import { apiRequest } from "../api.js";

// 获取操作指南
export function getGuide(config) {
  config.method = "get";
  config.url = "/app-api/person/login/get-front-url";
  apiRequest(config);
}

// 提交视频
export function setVideoRecord(config) {
  config.method = "post";
  config.url = "/app-api/website/news/send-media-record";
  apiRequest(config);
}

//获取视频详情
export function getVideoDetail(config) {
  config.method = "get";
  config.url = "/app-api/website/news/get-video-detail";
  apiRequest(config);
}

// 获取视频列表
export function getVideoList(config) {
  config.method = "get";
  config.url = "/app-api/website/news/get-video";
  apiRequest(config);
}

// 获取视频分类
export function getVideoCate(config) {
  config.method = "get";
  config.url = "/app-api/website/news/get-video-cate";
  apiRequest(config);
}

// 资料下载
export function getFileDownload(config) {
  config.method = "post";
  config.url = "/adminapi/web/get-media";
  apiRequest(config);
}

// 会员校验
export function vipCheck(config) {
  config.method = "post";
  config.url = "/app-api/person/login/select-member";
  apiRequest(config);
}

// 获取首页banner
export function getIndexBanner(config) {
  config.method = "get";
  config.url = "/app-api/website/news/get-banner-page";
  apiRequest(config);
}

// 忘记密码
export function forgetPassword(config) {
  config.method = "post";
  config.url = "/app-api/person/login/password";
  apiRequest(config);
}

// 找回密码发送短信
export function findPassword(config) {
  config.method = "post";
  config.url = "/personapi/sms/find-password";
  apiRequest(config);
}

// 获取首页广告
export function getWorkArea(config) {
  config.method = "get";
  config.url = "/app-api/website/news/get-web-work-area";
  apiRequest(config);
}
// 获取优秀奖项详情
export function getIndexDetail(config) {
  config.method = "get";
  config.url = "/app-api/website/news/get-case-info";
  apiRequest(config);
}
// 获取首页推荐
export function getRecommended(config) {
  config.method = "get";
  config.url = "/app-api/website/news/get-web-recommend-news";
  apiRequest(config);
}

// 获取国家优质工程
export function getNewAwork(config) {
  config.method = "get";
  config.url = "/app-api/website/news/get-web-case";
  apiRequest(config);
}

//获取文章详情
export function getAtricDetail(config) {
  config.method = "get";
  config.url = "/app-api/website/news/get-post-detail";
  apiRequest(config);
}

//获取公司基本信息
export function getUserInfo(config) {
  config.method = "post";
  config.url = "/appapi/v1/member/get-member-info";
  apiRequest(config);
}

// 获取信息完善
export function getUserLeaders(config) {
  config.method = "post";
  config.url = "/appapi/v1/info/get-extra-msg";
  apiRequest(config);
}

// 去完善数据
export function setUserLeaders(config) {
  config.method = "post";
  config.url = "/appapi/v1/info/save-extra-msg";
  apiRequest(config);
}

//会员的缴费状态
export function getPayStatus(config) {
  config.method = "post";
  config.url = "/appapi/v1/info/get-pay-status";
  apiRequest(config);
}

//信息变更表格
export function getChangeList(config) {
  config.method = "post";
  config.url = "/appapi/v1/member/change-list";
  apiRequest(config);
}

// 信息变更新增
export function setChangeInfo(config) {
  config.method = "post";
  config.url = "/appapi/v1/member/save-info";
  apiRequest(config);
}

// 信息变更详情
export function getInfoDetail(config) {
  config.method = "post";
  config.url = "/appapi/v1/member/detail";
  apiRequest(config);
}

// 获取信息变更函地址
export function getInfoLink(config) {
  config.method = "post";
  config.url = "/appapi/v1/member/get-change-file";
  apiRequest(config);
}

// 获取会员缴费记录
export function getPayDetail(config) {
  config.method = "post";
  config.url = "/appapi/v1/pay/get-payment";
  apiRequest(config);
}
// 调用支付宝付款
export function PayAli(config) {
  config.method = "post";
  config.url = "/appapi/v1/pay/pay";
  apiRequest(config);
}

// 上传头像
export function submitActor(config) {
  config.method = "post";
  config.url = "/appapi/upload/upload-img";
  apiRequest(config);
}

// 上传申请表
export function submitApply(config) {
  config.method = "post";
  config.url = "/appapi/v1/member/get-sign-table";
  apiRequest(config);
}

// 活动积分鉴定
export function getIntegralUrl(config){
	config.method = 'get'
	config.url = '/app-api/website/news/get-url'
	apiRequest(config)
}

// 1.获取积分详情
export function getCurrentPoint(config){
  config.method = 'get'
	config.url = '/app-api/person/point/get-current-point'
	apiRequest(config)
}

// 获取积分信息 
export function getPointInfo(config){
  config.method = 'get'
	config.url = '/app-api/person/point/get-point-info'
	apiRequest(config)
}

// 3.获取积分明细
export function getPointDetail(config){
  config.method = 'get'
	config.url = '/app-api/person/point/get-point-detail'
	apiRequest(config)
}

// 按七大地区统计人数分布
export function getStatisticsRegion(config) {
  config.method = "get";
  config.url = "/app-api/person/statistics/region";
  apiRequest(config);
}

// 统计单位性质分布
export function getStatisticsCompanyType(config) {
  config.method = "get";
  config.url = "/app-api/person/statistics/company-type";
  apiRequest(config);
}

// 按省份统计人数分布
export function getStatisticsProvince(config) {
  config.method = "get";
  config.url = "/app-api/person/statistics/province";
  apiRequest(config);
}

// 统计学历分布
export function getStatisticsEducation(config) {
  config.method = "get";
  config.url = "/app-api/person/statistics/education";
  apiRequest(config);
}

// 统计会员等级分布
export function getStatisticsLevel(config) {
  config.method = "get";
  config.url = "/app-api/person/statistics/level";
  apiRequest(config);
}